import { render, staticRenderFns } from "./NewInvoice.vue?vue&type=template&id=467d85ac&scoped=true&"
import script from "./NewInvoice.vue?vue&type=script&lang=js&"
export * from "./NewInvoice.vue?vue&type=script&lang=js&"
import style0 from "./NewInvoice.vue?vue&type=style&index=0&id=467d85ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467d85ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('467d85ac')) {
      api.createRecord('467d85ac', component.options)
    } else {
      api.reload('467d85ac', component.options)
    }
    module.hot.accept("./NewInvoice.vue?vue&type=template&id=467d85ac&scoped=true&", function () {
      api.rerender('467d85ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Invoices/NewInvoice.vue"
export default component.exports